import React from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import DirectoryList from "../DirectoryList";
import HeroSection from "../../../layout/HeroSection";
import { pageRoutes } from "../../../routes/pageRoutes";

const Gallery = () => {
  const robotData = [
    {
      id: 1,
      imgSrc: "images/RC101Icons.ai_18.svg",
    },
    {
      id: 2,
      imgSrc: "images/RC101Icons.ai_19.svg",
    },
    {
      id: 3,
      imgSrc: "images/RC101Icons.ai_21.svg",
    },
    {
      id: 4,
      imgSrc: "images/RC101Icons.ai_22.svg",
    },
    {
      id: 5,
      imgSrc: "images/RC101Icons.ai_36.svg",
    },
    {
      id: 6,
      imgSrc: "images/RC101Icons.ai_18.svg",
    },
    {
      id: 7,
      imgSrc: "images/RC101Icons.ai_36.svg",
    },
    {
      id: 8,
      imgSrc: "images/RC101Icons.ai_18.svg",
    },
  ];

  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Gallery"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Gallery",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <DirectoryList robotData={robotData} isDetailed={false}/>

        <Footer />
      </div>
    </>
  );
};

export default Gallery;
